import _ from '@/lib/lodash';

export const breakthrough = {
  lg: 1050,
  md: 992,
  sm: 650,
};

const breakthroughKeys = Object.keys(breakthrough);

let currentState = getState();

export function initResponsive() {
  currentState = getState();
  return currentState;
}

export function isNeedResponsiveChange() {
  const newState = getState();
  return !_.isEqual(currentState, newState);
}

export function getState() {
  const width =
    window.innerWidth ||
    document.documentElement.clientWidth ||
    document.body.clientWidth;

  const result = {};

  breakthroughKeys.forEach((key) => {
    result[key] = width <= breakthrough[key];
  });

  return result;
}